export const MESSAGE_TYPE_TEXT = 'text';
export const MESSAGE_TYPE_MEDIA = 'media';
export const MESSAGE_TYPE_FILE = 'file';
export const MESSAGE_TYPE_ATTACHMENT = 'attachment';
export const MESSAGE_TYPE_LOCATION = 'location';

export const MESSAGE_TYPE_REQUEST = 'new_request';
export const MESSAGE_TYPE_FINISH = 'finish_consult';

export const MESSAGE_CATEGORY_CONSULT = 1;
export const MESSAGE_CATEGORY_FOLLOWUP = 0;
